/*
  1. install the firebase:-  npm install -g firebase-tools, npm install firebase
  2. Click on Project Overview -> Project Settings -> and scroll down
  3. Click on configuration radio button and copy the code (that code is copied and pasted in this file)
  4. Click on Authentication -> Signin method -> Email and enable it. 

  to deploy in firebase:-
    Prerequisite:- Firebase CLI v11.19.0 is incompatible with Node.js v14.17.1 Please upgrade Node.js to version ^14.18.0 || >=16.4.0

    1. run the following command:- firebase login
    2. after entering this command, a window will popup on the screen and we need to login to firebase.
    3. Now run :- firebase init command
    4. Select "Hosting: Configure files for Firebase Hosting and (optionally) set up GitHub Action deploys" option
    5. Press on the space button and select the option.
    6. Click on the Enter button.
    7. Click on user existing project
    8. Now select the project that you want to deploy
    9. Now it will ask:- "What do you want to use as your public directory?" 
    10. Type "build"
    11. For:- "Configure as a single-page app" type "y" and hit enter
    12. Once this is done, type:- npm run build
    13. by providing the above command, we are removing the unwanted contents from the project and creating an optimized project.
    14. Once it is done, run:- firebase deploy
*/
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCEkNK0zQ7cpJ-u1xOo1GAw7uhUjBJuU6Q",
  authDomain: "site-4f5a5.firebaseapp.com",
  projectId: "site-4f5a5",
  storageBucket: "site-4f5a5.appspot.com",
  messagingSenderId: "238633105480",
  appId: "1:238633105480:web:1346e2e6a39b8bdc0c407d",
  measurementId: "G-W03DZ91L60",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
